import {connect} from 'react-redux';

import {TeammateModel} from '../../../../../libs/shared/core/src/models/api/teammateModel';
import {getFlatActiveTeammates} from '../../../../../libs/shared/core/src/store/data/teammates/commonTeammatesSelectors';
import {DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {SearchTeammateDropdown} from './searchTeammateDropdown';

/*
 * Props.
 */

interface SearchTeammateDropdownContainerProps extends DropdownProps {
  selectedEmail: string | undefined;
  onChange: (model: TeammateModel) => void;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SearchTeammateDropdownContainerProps>()(() => ({
  teammates: getFlatActiveTeammates,
}));

export const SearchTeammateDropdownContainer = connect(mapStateToProps)(SearchTeammateDropdown);
